module.exports = __webpack_public_path__ + "img/box.0a575871.png";